// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-notification-table {
  white-space: nowrap;
}

.all-notification-header {
  display: -webkit-inline-box;
  border-bottom: 1px solid #eeeeee;
  width: 100%;
}

.allnotis-arrowClass {
  font-size: 25px;
  cursor: pointer;
  position: relative;
}

.download-btn {
  text-decoration: none !important;
  color: #333 !important;
}

.allnotis-arrowContainer {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
}

.fixed-table-header {
  position: sticky;
  top: 50px;
  background-color: #e4e4e4;
  z-index: 1;
  border-top: 1px solid #c9d6de !important;
  font-size: 16px !important;
}
.table-header {
  background-color: #e4e4e4;
  border-top: 1px solid #c9d6de !important;
}
.filter {
  position: relative;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.jusitfy-between {
  justify-content: space-between;
}
.filter-dialog {
  border-radius: 4px;
  border: 1px solid #c9d6de;
  position: absolute;
  top: 40px;
  right: 0px;
  z-index: 2;
  background-color: #ffffff;
  min-width: 200px;
}
.created-by-wapper {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  width: 180px;
  overflow: overlay;
}
.filter-dialog .padding-10 .form-group label,
.created-by-wapper label {
  font-weight: 500;
  font-size: 14px;
}
.margin-0 {
  margin: 0px;
}
.padding-0 {
  padding: 0px;
}
.fixed-time .clockpicker {
  border-left: 1px solid #c9d6de;
}
.fixed-time > div > .form-group {
  margin: 0px;
}
.padding-top-5 {
  padding-top: 5px;
}
.padding-bottom-5 {
  padding-bottom: 5px;
}
.week-badge {
  background-color: #c9d6de;
  width: 36px;
  height: 20px;
  border-radius: 4px 0 0 4px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.day-containor {
  background-color: #e4e4e4;
  border: 1px solid #c9d6de;
  border-radius: 4px;
  min-width: 45px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  font-size: 14px;
  cursor: pointer;
}
.day-containor-selected {
  background-color: #4bc96b;
  color: #ffffff;
}
.min-width-150 {
  min-width: 150px;
}
.text-sm {
  font-size: 13px !important;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/allNotificationCampaigns.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".all-notification-table {\n  white-space: nowrap;\n}\n\n.all-notification-header {\n  display: -webkit-inline-box;\n  border-bottom: 1px solid #eeeeee;\n  width: 100%;\n}\n\n.allnotis-arrowClass {\n  font-size: 25px;\n  cursor: pointer;\n  position: relative;\n}\n\n.download-btn {\n  text-decoration: none !important;\n  color: #333 !important;\n}\n\n.allnotis-arrowContainer {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 30px;\n}\n\n.fixed-table-header {\n  position: sticky;\n  top: 50px;\n  background-color: #e4e4e4;\n  z-index: 1;\n  border-top: 1px solid #c9d6de !important;\n  font-size: 16px !important;\n}\n.table-header {\n  background-color: #e4e4e4;\n  border-top: 1px solid #c9d6de !important;\n}\n.filter {\n  position: relative;\n}\n.flex {\n  display: flex;\n}\n.align-center {\n  align-items: center;\n}\n.jusitfy-between {\n  justify-content: space-between;\n}\n.filter-dialog {\n  border-radius: 4px;\n  border: 1px solid #c9d6de;\n  position: absolute;\n  top: 40px;\n  right: 0px;\n  z-index: 2;\n  background-color: #ffffff;\n  min-width: 200px;\n}\n.created-by-wapper {\n  display: flex;\n  flex-direction: column;\n  max-height: 200px;\n  width: 180px;\n  overflow: overlay;\n}\n.filter-dialog .padding-10 .form-group label,\n.created-by-wapper label {\n  font-weight: 500;\n  font-size: 14px;\n}\n.margin-0 {\n  margin: 0px;\n}\n.padding-0 {\n  padding: 0px;\n}\n.fixed-time .clockpicker {\n  border-left: 1px solid #c9d6de;\n}\n.fixed-time > div > .form-group {\n  margin: 0px;\n}\n.padding-top-5 {\n  padding-top: 5px;\n}\n.padding-bottom-5 {\n  padding-bottom: 5px;\n}\n.week-badge {\n  background-color: #c9d6de;\n  width: 36px;\n  height: 20px;\n  border-radius: 4px 0 0 4px;\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n}\n.day-containor {\n  background-color: #e4e4e4;\n  border: 1px solid #c9d6de;\n  border-radius: 4px;\n  min-width: 45px;\n  height: 36px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.day-containor-selected {\n  background-color: #4bc96b;\n  color: #ffffff;\n}\n.min-width-150 {\n  min-width: 150px;\n}\n.text-sm {\n  font-size: 13px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
